import styled from '@emotion/styled';
import { Text, Title } from 'components';
import { GrowingContainer } from 'components/PageWithBottomBar/PageWithBottomBar.style';

export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: ${({ theme }) => theme.base.spacing[5]};
    margin: ${({ theme }) => theme.base.spacing[2]};
    text-align: center;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const Content = styled(GrowingContainer)`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: ${({ theme }) => theme.base.spacing[2]};
`;

export const CommentContainer = styled.div`
    padding: ${({ theme }) => theme.base.spacing[2]};
    background-color: ${({ theme }) => theme.base.colors.secondary[200]};
    border-radius: ${({ theme }) => theme.base.radius.md};
    margin-bottom: ${({ theme }) => theme.base.spacing[2]};
`;

export const StyleTitleContainer = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.feature.thirdaryTextColor};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
`;

export const TitleAndTableNumberContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const StyledTitle = styled(Title)`
    padding-bottom: ${({ theme }) => theme.base.spacing[1]};
    margin-right: ${({ theme }) => theme.base.spacing[2]};
`;

export const StyledDate = styled(Text)`
    padding-bottom: ${({ theme }) => theme.base.spacing[1]};
`;

export const StyledNumberTitle = styled(Title)`
    font-weight: 800;
    margin-bottom: ${({ theme }) => theme.base.spacing[3]};
`;

export const MargedContainer = styled.div`
    margin-top: ${({ theme }) => theme.base.spacing[2]};
    margin-bottom: ${({ theme }) => theme.base.spacing[2]};
`;
